import {
    useMemo,
} from 'react'
import {
    DetailPanelComponentProps,
} from 'app/PoC/DataGridDemoPages/components/SkyNetDataGridExpandable'
import AdditionalFeesRequests from 'app/requests/ContractBasis/ContractBasis.requests'
import useContractBasisContext from 'app/Apps/Pricing/ContractBasis/hooks/useContractBasisContext'
import LaneGroupForm from 'app/Apps/Pricing/LaneGroups/LaneGroupForm'

const LaneGroupsCreate = ({
    onSuccess, onCancel,
}: Readonly<DetailPanelComponentProps>) => {
    const {
        contractId,
    } = useContractBasisContext()
    const requestParams = useMemo(() => {
        return AdditionalFeesRequests.createLaneGroup({
            contractId,
        })
    }, [contractId])

    return (
        <LaneGroupForm
            onSuccess={onSuccess}
            onCancel={onCancel}
            requestParam={requestParams}
        />
    )
}

export default LaneGroupsCreate
